/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { arrayMove } from "react-sortable-hoc";

/*component */
import PageInputs from "./PageInputs";
import SortableGrid from "../../../shared/SortableGrid";
import CollectionAccordion from "../../../shared/Forms/CollectionAccordion";

class Pages extends Component {
	constructor(props) {
		super(props);
		this.state = {
			count: 0,
			shouldDisable: false,
			expandedIndex: null,
			initialLoad: false,
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.values !== prevProps.values && this.props.values.pages && !this.state.initialLoad) {
			const { pages } = this.props.values;
			this.setState({
				count: pages.length,
				initialLoad: true,
			});
		}
	}

	getOptionsShown = shown => {
		if (shown) {
			this.setState({
				shouldDisable: true,
			});
		} else {
			this.setState({
				shouldDisable: false,
			});
		}
	};

	toggleCollectionItem = index => {
		const { expandedIndex } = this.state;
		if (expandedIndex === index) {
			this.setState({
				expandedIndex: null,
			});
		} else {
			this.setState({
				expandedIndex: index,
			});
		}
	};

	onSortEnd = ({ oldIndex, newIndex }) => {
		const { values, formApi } = this.props;
		if (values && values.pages) {
			const { setValues } = formApi;
			const { pages } = values;
			setValues({
				...values,
				pages: arrayMove(pages, oldIndex, newIndex),
			});
		}
	};

	addPage = () => {
		const { count } = this.state;
		this.setState({
			count: count + 1,
			expandedIndex: count,
		});
	};

	deletePage = index => {
		const { values, formApi } = this.props;
		const { count } = this.state;
		if (values && values.pages) {
			const { setValues } = formApi;
			const { pages } = values;
			this.setState(
				{
					count: count - 1,
				},
				setValues({
					...values,
					pages: [...pages.slice(0, index), ...pages.slice(index + 1)],
				})
			);
		} else if (count > 0) {
			this.setState({
				count: count - 1,
			});
		}
	};

	copyPage = index => {
		const { values, formApi } = this.props;
		const { count } = this.state;
		if (values && values.pages) {
			const { setValues } = formApi;
			const { pages } = values;
			this.setState(
				{
					count: count + 1,
				},
				setValues({
					...values,
					pages: [...pages, pages[index]],
				})
			);
		}
	};

	renderPages = () => {
		const { pages, values } = this.props;
		const { count, expandedIndex } = this.state;
		const value = values && values.pages ? values.pages : [];
		let pagesElements = [];
		for (var i = 0; i < count; i++) {
			const title = value[i] ? value[i].title : "";
			pagesElements.push(
				<CollectionAccordion
					key={i}
					title={title}
					expanded={expandedIndex === i}
					index={i}
					copyCollection={this.copyPage}
					deleteCollection={this.deletePage}
					toggleCollectionItem={this.toggleCollectionItem}
					getOptionsShown={this.getOptionsShown}
				>
					<PageInputs pages={pages} index={i} value={value[i]} />
				</CollectionAccordion>
			);
		}
		return pagesElements;
	};

	render() {
		const { shouldDisable } = this.state;

		return (
			<div>
				<SortableGrid
					shouldDisable={shouldDisable}
					onSortEnd={this.onSortEnd}
					createNew={this.addPage}
					title="Pages"
				>
					{this.renderPages()}
				</SortableGrid>
			</div>
		);
	}
}

Pages.propTypes = {
	values: PropTypes.object,
	formApi: PropTypes.object,
	pages: PropTypes.array,
};

export default Pages;
